import { EVENT_TYPE_ENUM, ROLES } from "@ets/enum/event-type.enum"
import { ALLOCATION, HOLDING_ALLOCATION } from "@ets/interfaces/allocate"
import { BENEFICIARY_ACCOUNT } from "../data/common/common-dropdown"

export const NOTIFICATIONS = {
    DURATION: 5000
}

// GPR-3027: ice class labels eligible for the 5% FuelEU energy credit (same eligibility as the
// backend's IceClassId IN (1, 2)).
export const ICE_CLASS_CREDIT_ELIGIBLE_LABELS = ['1A', '1A SUPER'];


export const SIDEBAR_CONST_KEYS = {
    ADD_COUNTER_PARTY: 'ADD_COUNTER_PARTY',
    ADD_REMARK: 'ADD_REMARK',
    VOYAGE_DATA: 'VOYAGE_DATA',
    EDIT_COUNTER: 'EDIT_COUNTER',
    ID:  'ID',
    MASTER_CARD_LIST_DROPDOWN: 'MASTER_CARD_LIST_DROPDOWN',
    MASTER_LIST_SELECTION_DATA_SHOW: 'MASTER_LIST_SELECTION_DATA_SHOW',
    COUNTER_PARTY_LIST_SHOW: 'COUNTER_PARTY_LIST_SHOW',
    ADD_NEW_REMARK: 'ADD_NEW_REMARK',

}

export const TABLE_HEAD_MENU = {
    map: {
        icon: 'fi-map.svg',
        title: 'map-view'
    },
    list: {
        icon: 'fi-list.svg',
        title: 'list-view'
    }
}
export const API_URL = {
    VOYAGE_REMARK: 'voyage-remark',
    REMARK: 'remark',
    MASTER_LISTS: 'masterLists',
    VOYAGES: 'voyages',
    FLEETS: 'fleets',
    REMARKS: 'Remarks',
    ACCOUNTS: 'accounts',
    LINK_COUNTER_PARTIES: 'link-counter-parties',
    PASSAGES: 'passages',
    UPDATE_REMARKS: 'UpdateRemarks',
    ADD_REMARK: 'AddRemarks',
    MASTER_COUNTER_PARTY: 'MasterCounterParty',
    GET_MASTER_COUNTER_PARTY_DATA: 'GetMasterCounterPartyData',
    UPDATE_MASTER_COUNTER_PARTY: 'UpdateMasterCounterParty',
    GET_REMARKS_BY_VOYAGE_NUMBER: 'GetRemarksDataByVoyageNumber?VoyageNumber=',
    ACCOUNTS_DROPDOWN: 'Account/GetAccountData',
    FLEETS_DROPDOWN: 'Fleet/GetFleetData',
    VESSEL_DROPDOWN:'Vessels/GetVesselsData',
    LINKED_CP: 'LinkedCP',
    UPDATE_LINKED_CP: 'UpdateLinkedCP',
    GET_LINKED_CP: 'GetLinkedCPData',
    ADD_LINKED_CP: 'AddLinkedCP',
    DELETE_LINKED_CP: 'LinkedCP/DeleteLinkedCPById',
    DELETE_LINKED_CP_BY_MASTER_ID: 'LinkedCP/DeleteLinkedCPByMasterId',
    GET_LINKED_BY_VESSEL_NAME: 'GetLinkedCPByVesselName?VesselName=',
    INVOICE: 'Invoice',
    GET_INVOICE_DATA: 'GetInvoiceData',
    ADD_INVOICE: 'AddInvoice',
    UPDATE_INVOICE: 'UpdateInvoice',
    GET_VESSEL_VOYAGE_AND_PASSAGE:"UIAccount/GetEUAByVessleVoyageAndPassageOrAll",
    GET_EUA_BY_VESSEL_NAME: "UIAccount/GetEUAByVessleName?VesselName=",
    GET_EUA_ACCOUNTING: 'UIAccount/GetEUAAccountData',
    ADD_EUA_ACCOUNTING: 'UIAccount/AddEUAAccount',
    UPDATE_EUA_ACCOUNTING: 'UIAccount/UpdateEUAAccount',
    GET_REMARKS_DATA: "Remarks/GetRemarksData",
    ADD_ORDER:"Order/AddOrder",
    GET_ORDER_BY_ID:"Order/GetOrderDataById",
    GET_REQUESTS_BY_ID:"Request/GetRequestDataById",
    GET_REQUESTS:"Request/GetRequestData",
    UPDATE_REQUEST: "Request/UpdateRequest",
    GET_REQUESTS_BY_ACCOUNT_NUMBERS:"Request/GetRequestDataByAccountNumbers",
    GET_ORDER:"Order/GetOrderData",
    GET_ALLOCATION:"Allocation/GetAllocationData",
    GET_ALLOCATION_BY_ID:"Allocation/GetAllocationDataById",
    GET_ALLOCATIONS:"Allocation/GetAllocationsData",
    GET_ALLOCATION_BY_IDS:"Allocation/GetAllocationDataByIds",
    GET_OWNER:"Owner/GetOwnerData",
    ADD_OWNER: "Owner/AddOwner",
    UPDATE_OWNER: "Owner/UpdateOwner",
    ADD_ACCOUNTING_DOC: "AccountingDocs/AddAccountingDocs",
    GET_ACCOUNTING_DOC: "AccountingDocs/GetAccountingDocs",
    GET_PROCUREMENT: "EUAProcurement/GetEUAProcurementData",
    ADD_REQUEST: 'Request/AddRequest',
    EDIT_COUNTER_PARTY:'MasterCounterParty/UpdateMasterCounterParty',
    ADD_COUNTER_PARTY:'MasterCounterParty/AddListMasterCounterParty',
    ADD_USER_ACCOUNT:'Account/AddAccount',
    UPDATE_USER_ACCOUNT:'Account/UpdateAccount',
    ADD_USER_ROLES_USERS:'UserRoles/AddUserRoles' ,
    GET_USER_ROLES_USERS:'UserRoles/GetUserRolesData',
    UPDATE_USER_ROLES_USERS:'UserRoles/UpdateUserRoles',
    GET_ROLES:'Roles/GetRolesData',
    ADD_ROLES:'Roles/AddRoles',
    UPDATE_ROLES:'Roles/UpdateRoles',
    GET_REPORTS:'Reports/GetReportsData',
    ADD_REPORTS:'Reports/AddReports',
    UPDATE_REPORTS:'Reports/UpdateReports',
    DELETE_REMARK_BY_ID: 'Remarks/DeleteRemarkById',
    UPDATE_ORDERS: 'Order/UpdateOrder',
    DELETE_REPORTS:'Reports/DeleteReportById',
    GET_HELP_CATEGORY:'HelpCategory/GetHelpCategoryData',
    ADD_HELP_CATEGORY:'HelpCategory/AddHelpCategory',
    GET_FAQ:'FAQ/GetFAQData',
    GET_FAQ_BYHELP_ID:'FAQ/GetFAQDataById',
    ADD_FAQ:'FAQ/AddFAQ',
    GET_FAQ_VIDEO:'FAQVideo/GetFAQVideoData',
    GET_FAQ_VIDEO_BYHELP_ID:'FAQVideo/GetFAQVideoDataById',
    ADD_FAQ_VIDEO:'FAQVideo/AddFAQVideo',
    UPDATE_FAQ:'FAQ/UpdateFAQ',
    GET_GEOPERFORM_MRV: 'https://geoperform-uat-voyage-api.azurewebsites.net/api/MRV/geteumrvvoyagedetailsforexternalapi',
    UPDATE_FAQ_VIDEO:'FAQVideo/UpdateFAQVideo',
    GET_HELP_CATEGORY_BYID:'HelpCategory/GetHelpCategoryDataById',
    DELETE_FAQ_VIDEO:'FAQVideo/DeleteFAQById',
    DELETE_FAQ:'FAQ/DeleteFAQById',
    GET_ORDER_REQUESTED_BY_ACCOUNT_BY_STATUS: 'OrderRequest/GetOrderRequestDataByAccountNumberAndStatus',
    ADD_ALLOCATION: 'Allocation/AddAllocation',
    UPDATE_ALLOCATION: 'Allocation/UpdateAllocation',
    GET_ACCOUNT_USER:'AccountsUsers/GetAccountsUsersData',
    GET_ACCOUNT_BY_USER_ID:'AccountsUsers/GetAccountsByUserId',
    ADD_ACCOUNT_USER:'AccountsUsers/AddAccountsUsers',
    EDIT_ACCOUNT_USER:'AccountsUsers/UpdateAccountsUsers',
    DELETE_ACCOUNT_USERS:'AccountsUsers/DeleteAccountsUserByEmail',
    GET_BENEFICIARY_ACCOUNT_USER:'BeneficiaryAccount/GetBeneficiaryAccounts',
    ADD_BENEFICIARY_ACCOUNT_USER:'BeneficiaryAccount/AddBeneficiaryAccount',
    EDIT_BENEFICIARY_ACCOUNT_USER:'BeneficiaryAccount/UpdateBeneficiaryAccount',
    DELETE_BENEFICIARY_ACCOUNT_USER:'BeneficiaryAccount/DeleteBeneficiaryAccountById',
    GET_TRADERS:'Traders/GetTraders',
    ADD_TRADERS:'Traders/AddTraders',
    EDIT_TRADERS:'Traders/UpdateTraders',
    DELETE_TRADERS:'Traders/DeleteTradersById',
    DELETE_ALLOCATION: 'Allocation/DeleteAllocationById',
    GET_ROLE_PRIV_BY_USER_ID:'UserRoles/GetUserRolesDataByUserId',
    DELETE_ROLE: 'Roles/DeleteRolesDataById',
    DELETE_USER_ROLE: 'UserRoles/DeleteUserRolesDataById',
    GET_EMISSION_ACCOUNTING: 'EmissionAccounting/GetEmissionAccountingData',

    ADD_EMISSION_ACCOUNTING: 'EmissionAccounting/AddEmissionAccounting',
    UPDATE_EMISSION_ACCOUNTING: 'EmissionAccounting/UpdateEUAAccount',

    ADD_NOTIFICATIONS: 'Notification/AddNotifications',
    GET_NOTIFICATIONS: 'Notification/GetNotifications',
    GET_NOTIFICATIONS_BY_ACCOUNT: 'Notification/GetNotificationsDataByAccount',
    ADD_OVERVIEW_LIMIT_SETTING: 'OverviewLimitSettings/AddOverviewLimitSettings',
    UPDATE_OVERVIEW_LIMIT_SETTING: 'OverviewLimitSettings/UpdateOverviewLimitSettings',
    GET_OVERVIEW_LIMIT_SETTING_BY_USER_ID: 'OverviewLimitSettings/GetOverviewLimitSettingByUserId',
    
}

export const ACTIVE_ROLES = {
    ROLE: ROLES.CHECKER 
}

export const ETS_TABS_HEADER = {
    OVERVIEW: 'OVERVIEW',
    VOYAGE_DATA: 'VOYAGE_DATA',
    EMISSION_ACCOUNTING: 'EMISSION_ACCOUNTING',
    EUA_ACCOUNTING: 'EUA_ACCOUNTING',
    EUA_INVOICING: 'EUA_INVOICING',
    EUA_PROCUREMENT: 'EUA Procurement'
}
export const USER_MANAGEMENT_TABS_HEADER = {
    ACCOUNTS: 'ACCOUNTS',
    COUNTER_PARTIES: 'COUNTER_PARTIES',
    USER_ROLES: 'USER_ROLES',
    USERS: 'USERS',
    USERS_ACCOUNT:'USERS_ACCOUNT',
    BENEFICIARY_ACCOUNT:'BENEFICIARY_ACCOUNT',
    TRADERS: 'TRADERS'
   
}

export const ETS_TABS = {
    [ETS_TABS_HEADER.OVERVIEW] : {header: 'Overview', content: 'Content for Overview', url: "overview"},
    [ETS_TABS_HEADER.VOYAGE_DATA]: { header: 'Voyage Data', content: 'Content for Voyage Data', url: "voyage-data"},
    [ETS_TABS_HEADER.EMISSION_ACCOUNTING]: {header: 'Emission accounting',content: 'Content for Emission accounting', url: "emission-accounting"},
    [ETS_TABS_HEADER.EUA_ACCOUNTING]: { header: 'EUA Accounting', content: 'Content for EUA Accounting', url: "eua-accounting"},
    [ETS_TABS_HEADER.EUA_INVOICING]: { header: 'EUA Invoicing', content: 'Content for EUA Invoicing', url: "eua-invoicing"},
    [ETS_TABS_HEADER.EUA_PROCUREMENT]: { header: 'EUA Procurement', content: 'Content for EUA Procurement', url: "eua-procurement"},
}
export const USER_MANAGEMENT_TABS = {
    [USER_MANAGEMENT_TABS_HEADER.ACCOUNTS] : {header: 'Accounts', content: 'Content for Accounts'},
    [USER_MANAGEMENT_TABS_HEADER.COUNTER_PARTIES]: { header: 'Counter Parties', content: 'Content for Counter Parties' },
    [USER_MANAGEMENT_TABS_HEADER.USER_ROLES]: {header: 'Roles',content: 'Content for Roles',},
    [USER_MANAGEMENT_TABS_HEADER.USERS]: { header: 'Users Role', content: 'Content for Users Role' },
    [USER_MANAGEMENT_TABS_HEADER.USERS_ACCOUNT]: { header: 'User Accounts', content: 'Content for User Accounts' },
    [USER_MANAGEMENT_TABS_HEADER.BENEFICIARY_ACCOUNT]: { header: 'Beneficiary Account', content: 'Content for Beneficiary Account' },
    [USER_MANAGEMENT_TABS_HEADER.TRADERS]: { header: 'Traders', content: 'Content for Traders' },
}

export const LOCAL_STORAGE = {
    CURRENT_USER: 'currentUser'
}

export const REMARK_TYPE = {
    VOYAGE: 'VOYAGE',
    PASSAGE: 'PASSAGE',
    VESSEL: 'VESSEL'
}
export const ETS_EUA_INVOICING_TABS_HEADER = {
    ALL: 'All',
    SUBMITTED: 'Submitted for Review',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    SETTLED: 'Settled',
    RECEIVED: 'Received',
    PENDING: 'Pending'
};
export const ACCOUNTING_TABS_HEADER = {
    REQUESTS: 'Requests',
    ORDERS: 'Orders',
    ALLOCATIONS: 'Allocations',
    TO_OWNER: 'To Owner',
   
};


export const ETS_EUA_INVOICING_TABS = {
    [ETS_EUA_INVOICING_TABS_HEADER.ALL]: { header: 'All', content: 'All' },
    [ACTIVE_ROLES.ROLE !== ROLES.CHECKER ? ETS_EUA_INVOICING_TABS_HEADER.SUBMITTED: ETS_EUA_INVOICING_TABS_HEADER.PENDING]: (ACTIVE_ROLES.ROLE !== ROLES.CHECKER ? { header: 'Submitted for Review', content: 'Submitted for Review'}: { header: 'Pending for Review', content: 'Pending for Review'}),
    [ETS_EUA_INVOICING_TABS_HEADER.APPROVED]: { header: 'Approved', content: 'Approved' },
    [ETS_EUA_INVOICING_TABS_HEADER.REJECTED]: { header: 'Rejected', content: 'Rejected' },
    [ETS_EUA_INVOICING_TABS_HEADER.SETTLED]: { header: 'Settled', content: 'Settled' },
    [ETS_EUA_INVOICING_TABS_HEADER.RECEIVED]: { header: 'Received', content: 'Received' }
};
export const ACCOUNTING_TABS = {
    [ACCOUNTING_TABS_HEADER.REQUESTS]: { header: 'Requests', content: 'Requests' },
    [ACCOUNTING_TABS_HEADER.ORDERS]: { header: 'Orders', content: 'Orders' },
    [ACCOUNTING_TABS_HEADER.ALLOCATIONS]: { header: 'Allocations', content: 'Allocations' },
    [ACCOUNTING_TABS_HEADER.TO_OWNER]: { header: 'To Owner', content: 'To Owner' }, 
};




export const OVERVIEW_FLEET_TABS_HEADER:any = {
    FLEET_1: 'Fleet 1',
    FLEET_2: 'Fleet 2'
};

export const OVERVIEW_FLEET_TABS = {
    [OVERVIEW_FLEET_TABS_HEADER.FLEET_1]: { header: OVERVIEW_FLEET_TABS_HEADER.FLEET_1, content: OVERVIEW_FLEET_TABS_HEADER.FLEET_1 },
    [OVERVIEW_FLEET_TABS_HEADER.FLEET_2]: { header: OVERVIEW_FLEET_TABS_HEADER.FLEET_2, content: OVERVIEW_FLEET_TABS_HEADER.FLEET_2 },
}

export const CURRENCIES = {
    EUR: 'EUR',
    USD: 'USD',
    // INR: 'INR',
    EUA: 'EUA',
}

export const CONVERSION_RATE:any ={
    [CURRENCIES.EUR]: {
        label: CURRENCIES.EUR,
        conversionRate: 75,
        code: CURRENCIES.EUR,
        symbol: '€',
        name: 'Euro (€)'
    },
    [CURRENCIES.USD]: {
        label: CURRENCIES.USD,
        conversionRate: 1,
        code: CURRENCIES.USD,
        symbol: '$',
        name: 'Dollar ($)'
    },
    [CURRENCIES.EUA]: {
        label: CURRENCIES.EUA,
        conversionRate: 1,
        code: CURRENCIES.EUA,
        symbol: 'EUA',
        name: 'EUA'
    },
    // [CURRENCIES.INR]: {
    //     label: CURRENCIES.INR,
    //     conversionRate: 90.11,
    //     code: CURRENCIES.INR,
    //     symbol: '₹'
    // }
}

export const ADDITIONAL_OPTIONS_OF_INVOICE_TYPE_KEY = {
    EUA_AND_USD : CURRENCIES.EUA + ' & ' + CURRENCIES.USD,
    EUA_AND_EUR : CURRENCIES.EUA + ' & ' + CURRENCIES.EUR
}

export const ADDITIONAL_OPTIONS_OF_INVOICE_TYPE:any = {
    [ADDITIONAL_OPTIONS_OF_INVOICE_TYPE_KEY.EUA_AND_USD]: {
        label: ADDITIONAL_OPTIONS_OF_INVOICE_TYPE_KEY.EUA_AND_USD,
        conversionRate: 75,
        code: ADDITIONAL_OPTIONS_OF_INVOICE_TYPE_KEY.EUA_AND_USD,
        symbol: 'EUA & $',
        name: 'EUA & Dollar($)'
    },
    [ADDITIONAL_OPTIONS_OF_INVOICE_TYPE_KEY.EUA_AND_EUR]: {
        label: ADDITIONAL_OPTIONS_OF_INVOICE_TYPE_KEY.EUA_AND_EUR,
        conversionRate: 75,
        code: ADDITIONAL_OPTIONS_OF_INVOICE_TYPE_KEY.EUA_AND_EUR,
        symbol: 'EUA & €',
        name: 'EUA & Euro(€)'
    }
}


export const INVOICING_TYPE = {
    active: EVENT_TYPE_ENUM.ADD
}

export const EUA_INVOICING_PAGES = {
    [EVENT_TYPE_ENUM.GENERATE_INVOICE]: {
        id: 0,
        label: EVENT_TYPE_ENUM.GENERATE_INVOICE,
    },
    [EVENT_TYPE_ENUM.PREVIEW_INVOICE]: {
        id: 0,
        label: EVENT_TYPE_ENUM.PREVIEW_INVOICE
    }
}

export const EUA_INVOICES_GENERATE_AND_PREVIEW:any = {
    active: EUA_INVOICING_PAGES[EVENT_TYPE_ENUM.GENERATE_INVOICE]
}

export const RECEIVABLE_TYPES_VALUES = {
  ToBeReceived: "toBeReceived",
  Received: "received",
  Disputed: "disputed"
}

export const PAYABLES_TYPES_VALUES = {
  ToBeDelivered: "toBeDelivered",
  Delivered: "delivered",
  Disputed: "disputed"
}

export const HOLDING_TYPES_VALUES = {
  Exposure: "Exposure",
  TaxableEmission: "TaxableEmission"
}

export const OVERVIEW_CHART_TYPES = {
  Receivables: "Receivables",
  Payables: "Payables",
  Holdings: "Holdings"
}

export const RECEIVABLE_TYPES = [
  {
      name: 'To Be Received',
      value: RECEIVABLE_TYPES_VALUES.ToBeReceived
  },
  {
      name: 'Received',
      value: RECEIVABLE_TYPES_VALUES.Received
  },
  {
      name: 'Disputed',
      value: RECEIVABLE_TYPES_VALUES.Disputed
  },
]

export const PAYABLES_TYPES = [
  {
      name: 'To Be Delivered',
      value: PAYABLES_TYPES_VALUES.ToBeDelivered
  },
  {
      name: 'Delivered',
      value: PAYABLES_TYPES_VALUES.Delivered
  },
  // {
  //     name: 'Disputed',
  //     value: PAYABLES_TYPES_VALUES.Disputed
  // },
]

export const HOLDING_TYPES = [
  {
      name: 'Exposure',
      value: HOLDING_TYPES_VALUES.Exposure
  },
  {
      name: 'Taxable Emissions',
      value: HOLDING_TYPES_VALUES.TaxableEmission
  }
  // {
  //     name: 'Disputed',
  //     value: PAYABLES_TYPES_VALUES.Disputed
  // },
]


export const FILTERS:any = {
  "reset": false,
  "filters": {
      "account": [
          {
              "accountNumber": "ABCDE12345",
              "alias": "ABCDE12345",
              "accountName": "ABCDE12345",
              "registry": "India",
              "fleets": [
                  {
                      "fleetID": 1,
                      "fleetName": "Scorpio Handymax Pool",
                      "vessels": [
                          {
                              "vesselID": 1,
                              "vesselName": "STI Clapham",
                              "imoNumber": "9696577",
                              "createdBy": 293,
                              "createdDate": "2024-09-19T13:44:49.0282264+00:00",
                              "modifiedBy": 293,
                              "modifiedDate": "2024-09-19T13:44:49.0282276+00:00",
                              "isActive": true
                          },
                          {
                              "vesselID": 2,
                              "vesselName": "STI COMANDANTE",
                              "imoNumber": "9686857",
                              "createdBy": 293,
                              "createdDate": "2024-09-19T13:44:49.0289616+00:00",
                              "modifiedBy": 293,
                              "modifiedDate": "2024-09-19T13:44:49.0289627+00:00",
                              "isActive": true
                          },
                          {
                              "vesselID": 3,
                              "vesselName": "STI HAMMERSMITH",
                              "imoNumber": "9706463",
                              "createdBy": 293,
                              "createdDate": "2024-09-19T13:44:49.0289716+00:00",
                              "modifiedBy": 293,
                              "modifiedDate": "2024-09-19T13:44:49.0289717+00:00",
                              "isActive": true
                          },
                          {
                              "vesselID": 4,
                              "vesselName": "STI PIMLICO",
                              "imoNumber": "9686871",
                              "createdBy": 293,
                              "createdDate": "2024-09-19T13:44:49.0289746+00:00",
                              "modifiedBy": 293,
                              "modifiedDate": "2024-09-19T13:44:49.0289747+00:00",
                              "isActive": true
                          }
                      ],
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0277418+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0277457+00:00",
                      "isActive": true
                  },
                  {
                      "fleetID": 2,
                      "fleetName": "Scorpio LR2 Pool",
                      "vessels": [
                          {
                              "vesselID": 5,
                              "vesselName": "BAHRA",
                              "imoNumber": "9595008",
                              "createdBy": 293,
                              "createdDate": "2024-09-19T13:44:49.0292238+00:00",
                              "modifiedBy": 293,
                              "modifiedDate": "2024-09-19T13:44:49.0292239+00:00",
                              "isActive": true
                          },
                          {
                              "vesselID": 6,
                              "vesselName": "STI ELYSEES",
                              "imoNumber": "9688829",
                              "createdBy": 293,
                              "createdDate": "2024-09-19T13:44:49.0292267+00:00",
                              "modifiedBy": 293,
                              "modifiedDate": "2024-09-19T13:44:49.0292267+00:00",
                              "isActive": true
                          },
                          {
                              "vesselID": 7,
                              "vesselName": "STI GRACE (OP)",
                              "imoNumber": "9722584",
                              "createdBy": 293,
                              "createdDate": "2024-09-19T13:44:49.0292289+00:00",
                              "modifiedBy": 293,
                              "modifiedDate": "2024-09-19T13:44:49.0292289+00:00",
                              "isActive": true
                          }
                      ],
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0292165+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.029217+00:00",
                      "isActive": true
                  }
              ],
              "createdBy": 293,
              "createdDate": "2024-09-19T13:44:49.0172625+00:00",
              "modifiedBy": 293,
              "modifiedDate": "2024-09-19T13:44:49.0172704+00:00",
              "isActive": true,
              "name": "ABCDE12345",
              "id": "ABCDE12345"
          }
      ],
      "fleets": [
          {
              "fleetID": 1,
              "fleetName": "Scorpio Handymax Pool",
              "vessels": [
                  {
                      "vesselID": 1,
                      "vesselName": "STI Clapham",
                      "imoNumber": "9696577",
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0282264+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0282276+00:00",
                      "isActive": true
                  },
                  {
                      "vesselID": 2,
                      "vesselName": "STI COMANDANTE",
                      "imoNumber": "9686857",
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0289616+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0289627+00:00",
                      "isActive": true
                  },
                  {
                      "vesselID": 3,
                      "vesselName": "STI HAMMERSMITH",
                      "imoNumber": "9706463",
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0289716+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0289717+00:00",
                      "isActive": true
                  },
                  {
                      "vesselID": 4,
                      "vesselName": "STI PIMLICO",
                      "imoNumber": "9686871",
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0289746+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0289747+00:00",
                      "isActive": true
                  }
              ],
              "createdBy": 293,
              "createdDate": "2024-09-19T13:44:49.0277418+00:00",
              "modifiedBy": 293,
              "modifiedDate": "2024-09-19T13:44:49.0277457+00:00",
              "isActive": true
          },
          {
              "fleetID": 2,
              "fleetName": "Scorpio LR2 Pool",
              "vessels": [
                  {
                      "vesselID": 5,
                      "vesselName": "BAHRA",
                      "imoNumber": "9595008",
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0292238+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0292239+00:00",
                      "isActive": true
                  },
                  {
                      "vesselID": 6,
                      "vesselName": "STI ELYSEES",
                      "imoNumber": "9688829",
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0292267+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0292267+00:00",
                      "isActive": true
                  },
                  {
                      "vesselID": 7,
                      "vesselName": "STI GRACE (OP)",
                      "imoNumber": "9722584",
                      "createdBy": 293,
                      "createdDate": "2024-09-19T13:44:49.0292289+00:00",
                      "modifiedBy": 293,
                      "modifiedDate": "2024-09-19T13:44:49.0292289+00:00",
                      "isActive": true
                  }
              ],
              "createdBy": 293,
              "createdDate": "2024-09-19T13:44:49.0292165+00:00",
              "modifiedBy": 293,
              "modifiedDate": "2024-09-19T13:44:49.029217+00:00",
              "isActive": true
          }
      ],
      "vessels": [
          {
              "vesselID": 1,
              "vesselName": "STI Clapham",
              "imoNumber": "9696577",
              "createdBy": 293,
              "createdDate": "2024-09-19T13:44:49.0282264+00:00",
              "modifiedBy": 293,
              "modifiedDate": "2024-09-19T13:44:49.0282276+00:00",
              "isActive": true
          },
          {
              "vesselID": 2,
              "vesselName": "STI COMANDANTE",
              "imoNumber": "9686857",
              "createdBy": 293,
              "createdDate": "2024-09-19T13:44:49.0289616+00:00",
              "modifiedBy": 293,
              "modifiedDate": "2024-09-19T13:44:49.0289627+00:00",
              "isActive": true
          },
          {
              "vesselID": 3,
              "vesselName": "STI HAMMERSMITH",
              "imoNumber": "9706463",
              "createdBy": 293,
              "createdDate": "2024-09-19T13:44:49.0289716+00:00",
              "modifiedBy": 293,
              "modifiedDate": "2024-09-19T13:44:49.0289717+00:00",
              "isActive": true
          },
          {
              "vesselID": 4,
              "vesselName": "STI PIMLICO",
              "imoNumber": "9686871",
              "createdBy": 293,
              "createdDate": "2024-09-19T13:44:49.0289746+00:00",
              "modifiedBy": 293,
              "modifiedDate": "2024-09-19T13:44:49.0289747+00:00",
              "isActive": true
          }
      ],
      "dateRange": {
          "show": "Last 12 months",
          "actual": {
              "end": "30 Sep, 2024",
              "start": "01 Jan, 2024"
          }
      },
      "vesselTypes": [
          {
              "imoNumber": "9696577",
              "vesselType": "Chemical Tanker",
              "vesselCode": "TCLA"
          },
          {
              "imoNumber": "9686857",
              "vesselType": "Chemical Tanker",
              "vesselCode": "TCOM"
          },
          {
              "imoNumber": "9706463",
              "vesselType": "Chemical Tanker",
              "vesselCode": "THAM"
          },
          {
              "imoNumber": "9686871",
              "vesselType": "Chemical Tanker",
              "vesselCode": "TICO"
          }
      ]
  }
}

export const ALLOCATION_TABS = {
    ACCOUNT: {
        id: 1,
        label: "Account",
    },
    FLEETS: {
        id: 2,
        label: "Fleets",
    },
    VESSELS: {
        id: 3,
        label: 'Vessels'
    },
    VOYAGES: {
        id: 4,
        label: 'Voyages'
    },
    PASSAGES: {
      id: 5,
      label: 'Passages'
    }
}

export const ALLOCATION_STEP:any = {
    1: ALLOCATION_TABS.ACCOUNT,
    2: ALLOCATION_TABS.FLEETS,
    3: ALLOCATION_TABS.VESSELS,
    4: ALLOCATION_TABS.VOYAGES,
    5: ALLOCATION_TABS.PASSAGES
}

export const ACCOUNT_ALLOCATION = {
    isAccountAllocate: false,
    activeTab: ALLOCATION_TABS.ACCOUNT
}
export const USER_ROLE_ACCORDION_TABS = [
    {
      label: 'Overview',
      id: 'overview',
      sections: [
      {
        title: '',
        permissions: [
          { label: 'Download', controlName: 'download' },
        ]
      }]
    },
    {
      label: 'Voyage Data',
      id: 'voyageData',
      sections: [
        {
          title: 'CP Details',
          permissions: [
            { label: 'Add', controlName: 'cpAdd' },
            { label: 'Edit', controlName: 'cpEdit' },
            { label: 'Delete', controlName: 'cpDelete' }
          ]
        }
      ]
    },
    {
      label: 'Emission Accounting',
      id: 'emissionAccounting',
      sections: [
        {
          title: 'Voyage Details',
          permissions: [
            { label: 'Edit', controlName: 'cpEdit' },
          ]
        },
      ]
    },
    {
      label: 'EUA Accounting',
      id: 'euaAccounting',
      sections: [
        {
          title: 'Voyage Details',
          permissions: [
            { label: 'Edit', controlName: 'cpEdit' },
            { label: 'Copy Passage', controlName: 'cpCopy' },
            { label: 'Delete Passage Copy', controlName: 'cpDelete' },
            { label: 'Submit for Review', controlName: 'cpSubmitReview' },
            { label: 'Approve', controlName: 'cpApprove' },
            { label: 'Reject', controlName: 'cpReject' },
          ]
        }
      ]
    },
    {
      label: 'Invoicing',
      id: 'invoicing',
      sections: [
        {
          title: 'Invoicing',
          permissions: [
            { label: 'Generate', controlName: 'cpGenerate' },
            { label: 'Edit', controlName: 'cpEdit' },
            { label: 'Delete', controlName: 'cpDelete' },
            { label: 'Update Status', controlName: 'cpUpdateStatus' },
            { label: 'Submit for Review', controlName: 'cpSubmitReview' },
            { label: 'Approve and Send', controlName: 'cpApproveSend' },
            { label: 'Reject', controlName: 'cpReject' },
          ]
        }
      ]
    },
    {
      label: 'Procurement',
      id: 'procurement',
      sections: [
        {
          title: 'Request',
          permissions: [
            { label: 'Place Request', controlName: 'cpPlaceRequest' }
          ]
        },
        {
          title: 'Download',
          permissions: [
            { label: 'Download', controlName: 'download' }
          ]
        }
      ]
    },
    {
      label: 'ETS Accounting',
      id: 'etsAccounting',
      sections: [
        {
          title: '',
          permissions: [
            { label: 'Order Manually', controlName: 'cpOrderManually' }
          ]
        },
        {
            title: 'Request',
            permissions: [
              { label: 'Place Order', controlName: 'cpPlaceOrder' },
              { label: 'Cancel Request', controlName: 'cpCancelRequest' },
              { label: 'Change Status', controlName: 'cpChangeStatus' }
            ]
          },
        {
          title: 'Orders',
          permissions: [
            { label: 'Change Status', controlName: 'cpChangeStatus' },
            { label: 'Download Report', controlName: 'cpDownloadReport' },
            { label: 'Allocate', controlName: 'cpAllocate' },
            { label: 'Reverse Allocation', controlName: 'cpReverseAllocation' }
          ]
        },
        {
          title: 'To Owners',
          permissions: [
            { label: 'Deliver EUAs', controlName: 'cpDeliverEua' }
          ]
        }
      ]
    }, {
      label: 'Reports',
      id: 'reports',
      sections: [
      {
        title: '',
        permissions: [
          { label: 'Generate', controlName: 'reportGenerate' },
          { label: 'Download', controlName: 'reportDownload' },
          { label: 'Save', controlName: 'reportSave' },
          { label: 'Delete', controlName: 'reportDelete' }
        ]
      }]
    }
  ];


  const NEW_HOLDING_ALLOCATION_VALUE:HOLDING_ALLOCATION = {
    total: 0,
    allocated: 0,
  }
  export const NEW_ALLOCATION: ALLOCATION = { avgExchangeRate: '', conversionToDollarRate:0, totalRequested: 0, totalOrderd: 0, holding: NEW_HOLDING_ALLOCATION_VALUE, orders: new Map(), account: ''} 